import React, { useEffect, useState } from "react";
import ReportOptions from "../ReportOptions";
import { Button } from "bootstrap";
import { useNavigate } from "react-router-dom";
import { proxy } from '../../process/api';
import DynamicDTFloat from "../DynamicDTFloat";
import DropDownControl from "../DropDownControl";
import BrandedLoader from "../BrandedLoader";
import { hst03_report_json_format, generateExcel, getHeaderColNames, excelColorCodes, transformNavDataForLabels, goFullScreen,getUserType } from "../../utils";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import ProcessLoader from "../ProcessLoader";

const BI07 = () => {

    const navigate = useNavigate();
  const userType = getUserType();
    const div_data = JSON.parse(localStorage.getItem('div_data'));
    const year_data = JSON.parse(localStorage.getItem('year_data'));
    const month_data = JSON.parse(localStorage.getItem('month_data'));
    const depo_data = JSON.parse(localStorage.getItem('depo_data')).data.filter(item => item.value !== 0);

    console.log(depo_data);
    const seleted_div_value = localStorage.getItem('selected_div');
    const [showOptions, setShowOptions] = useState(true);
    const [reportGenData, setreportGenData] = useState({});
    const [SelectedDiv, setSelectedDIV] = useState(seleted_div_value);
    const [SelectedYear, setSelectedYear] = useState(
        () => localStorage.getItem('abmSelectedYear') ?? year_data.data[0].value
      );

     

    const [SelectedDepo, setSelectedDepo] = useState(depo_data[0].value);
     const [SelectedStartMonth, setSelectedStartMonth] = useState(
        () => localStorage.getItem('abmSelectedMonth') ?? month_data.data[0].value
      );
      
    const [SelectedEndMonth, setSelectedEndMonth] = useState(month_data.data[month_data.index - 1].value);
    const [BranchHQ, setBranchHQ] = useState(1);
    const [HQvalues, setHQValues] = useState({ data: [] });
    const [SelectedHQ, setSelectedHQ] = useState(0);
    const [showHQLoading, setHQLoading] = useState(false);
    const [showProcessLoader, setShowProcessLoader] = useState(false);
    const [pageTitle, setPageTitle] = useState('');

    const date = new Date();

const time = date.toLocaleTimeString("en-GB", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false
});

const day = String(date.getDate()).padStart(2, "0");
const month = date.toLocaleString("en-US", { month: "short" });
const year = date.getFullYear();

const formattedDate = `${time} ${day}-${month}-${year}`;
    
    
    const handleReportGen = async () => {

        if(SelectedHQ == ""){
            alert("Please select a Depo and HQ");
            return;
        }
        setShowProcessLoader(true);
        document.getElementById('btnReportGen').innerHTML = "PROCESSING...";
        
        const payload = {
            "myear": parseInt(SelectedYear),
            "div_code": parseInt(SelectedDiv),
            "depo_code": parseInt(SelectedDepo),

           "mnth_code": parseInt(`${String(SelectedStartMonth)}`, 10),


            "entry_date": formattedDate,

            "hq_code": parseInt(SelectedHQ),

        }

       

        var reportAPIResponse = {};
        reportAPIResponse = await proxy(`/api/mis/abm/report/savedraft`, payload, "post");

        if(reportAPIResponse?.abm_draft_id == "" || reportAPIResponse.status == "FAIL")
        {
            alert(reportAPIResponse.message);
        }else{
             navigate("/abm-report-01-edit/"+reportAPIResponse.abm_draft_id);

        }

        setShowProcessLoader(false);
        document.getElementById('btnReportGen').innerHTML = "CREATE NEW";
      
    }

    const loadHQList = async (year, div, branch) => {
        setHQLoading(true);
        const hqAPIResponse = await proxy(`/api/mis/hqlist/${year}/${div}/${branch}`, {}, "get");
        if (hqAPIResponse.data.length > 0) {
            setSelectedHQ(hqAPIResponse.data[0].value);
        } else {
            setSelectedHQ(0);
        }
        setHQValues(hqAPIResponse);
        setHQLoading(false);



    }
    const handleBranchChange = async (newValue) => {
        setSelectedDepo(newValue);
        loadHQList(SelectedYear, SelectedDiv, newValue);

    }

    useEffect(() => {
        loadHQList(SelectedYear, SelectedDiv, SelectedDepo);
        transformNavDataForLabels("AB01").then(title => {
            setPageTitle(title);
        });


    }, []);

    return (
        <>
            <div class="main-content">
                {showProcessLoader && <ProcessLoader />}
                {showOptions ?
                    <ReportOptions title={pageTitle} >
                        <div className="report-option-wrapper">
                            <div className="report-option-row">
                                <div className="report-option-item">
                                    <label>Division</label>
                                    <DropDownControl selectedValue={SelectedDiv} data={div_data.data} id="report_div_list" name="report_div_list" onChange={(newVal) => { setSelectedDIV(newVal); loadHQList(SelectedYear, newVal, SelectedDepo); }} />
                                </div>

                                <div className="report-option-item ml-20">
                                    <label>Branch</label>
                                    <DropDownControl data={depo_data} id="report_branch_list" name="report_branch_list"

                                        onChange={(newBranch) => { handleBranchChange(newBranch); }}
                                    />
                                </div>


                                <div className="report-option-item ml-20">
                                    <label>HQ</label>

                                    {showHQLoading ? <BrandedLoader /> :
                                        <DropDownControl
                                            data={HQvalues.data}
                                            id="report_hq_list"
                                            name="report_hq_list"
                                            onChange={(optionValue) => { setSelectedHQ(optionValue) }}
                                        />
                                    }
                                </div>


                            </div>

                            <div className="report-option-row">
                                <div className="report-option-item ">
                                    <label>Mkt&nbsp;Year</label>
                                    <DropDownControl data={year_data.data} id="report_mktyear_list" name="report_mktyear_list" onChange={(newYear) => { loadHQList(newYear, SelectedDiv, SelectedDepo); setSelectedYear(newYear) }} />

                                </div>

                                <div className="report-option-item ml-20">
                                    <label>For&nbsp;Month</label>
                                    <DropDownControl data={month_data.data} id="report_startyear_list" name="report_startyear_list" selectedValue={SelectedStartMonth} onChange={(val) => { console.log(val); setSelectedStartMonth(val) }} />
                                </div>

                                <div className="report-option-item ml-20">
                                    <label>Entry&nbsp;Date:&nbsp;{formattedDate}</label>
                                    
                                </div>




                            </div>







    
                            <div className="report-option-action-row">
                                <button onClick={(e) => { navigate('/dashboard'); }} className="btn btn-outline btn-md btn-sec mr-10 fw-500">BACK</button>

                                {userType == 4 &&
                                <button onClick={handleReportGen} className="btn btn-md btn-primary pr-30 pl-30 fw-500 " id="btnReportGen" >CREATE NEW</button>
}
                            </div>
                        </div>
                    </ReportOptions>
                    :
                    <>
                        
                    </>
                }


            </div>
        </>
    );


}

export default BI07;